export enum Routes {
  REGISTER = "/register",
  PROFILE = "/personal-info",
  PROJECTS = "/projects",
  PROJECTS_TIMELINE = "/projects-timeline",
  WORKLOG = "/work-log",
  TIME_OFF = "/time-off",
  TIME_OFF_REPORT = "/time-off-report",
  VACATION_REPORT = "/vacation-report",
  USERS = "/users",
  WORKLOG_REPORT = "/worklog-report",
  POSITIONS = "/positions",
  HOLIDAYS = "/holidays",
  ASSIGNATIONS = "/assignations",
  WORKLOGS_SUMMARY = "/worklogs-summary",
  CERTIFICATIONS = "/certifications",
  CANDIDATE_DETAIL = "/candidate-detail",
  ASSIGNATION_PROJECTION = "/assignation-projection",
  OVER_STAFF_REPORT = "/over-staff-report",
  CERTIFICATIONS_LIST = "/certifications-list",
  KNOWLEDGE_BASE_LIST = "/knowledge-base",
  IMAGE_TEMPLATE_BUILDER = "/image-template-builder",
  DASHBOARD = "/dashboard",
  FAQS = "/faqs",
  SITE = "/site",
  BADGES = "/badges",
  TIME_OFF_MISSING_HOURS = "/time-off-missing-hours",
  WORKLOG_MISSING_HOURS = "/worklog-missing-hours",
  ACCOMPLISHMENTS = "/accomplishments",
  PROPERTIES = "/properties",
  RANKING = "/ranking",
  ACCOMPLISHMENT_APPROVAL = "/accomplishment-approval",
  UNIFIED_REPORTS = "/unified-reports",
}
